export default {
  methods: {
    diferenciaDias(fecha) {
      const fechaHoy = this.$moment(new Date());
      const fecha2 = this.$moment(fecha);
      const diasDiferencia = fechaHoy.diff(fecha2, 'days');
      return diasDiferencia;
    },
    sumaDeMontoDelContratos(contratos) {
      const contratosAnticipos = contratos.map(({ anticipos }) => anticipos).flat();
      const contratosEstimaciones = contratos.map(({ estimaciones }) => estimaciones).flat();
      const contratosConvenios = contratos.map(({ modificado }) => modificado).flat();
      const contratosEscalatorias = contratos.map(({ escalatorias }) => escalatorias).flat();
      const contratosGastos = contratos.map(({ gastos }) => gastos).flat();

      const totalContratado = (
        this.$ObjSumar(contratos, 'total')
      + this.$ObjSumar(contratosConvenios, 'total')
      );
      const totalDeAnticipo = this.$ObjSumar(contratosAnticipos, 'total');
      const totalEstimaciones = this.$ObjSumar(contratosEstimaciones, 'totalFactura');
      const totalEscalatorias = this.$ObjSumar(contratosEscalatorias, 'total');
      const totalGastos = this.$ObjSumar(contratosGastos, 'total');

      const importeEscalatorias = this.$ObjSumar(contratosEscalatorias, 'importe');
      const importeGastos = this.$ObjSumar(contratosGastos, 'importe');
      const importeTotal = (
        this.$ObjSumar(contratos, 'importeTotal')
      + this.$ObjSumar(contratosConvenios, 'importe')
      );
      const importeEstimado = (
        this.$ObjSumar(contratosEstimaciones, 'importeEstimado')
        + importeEscalatorias
        + importeGastos
      );
      const importePorEstimar = (importeTotal - importeEstimado);

      const totalFacturado = (
        totalDeAnticipo
        + totalEstimaciones
        + totalEscalatorias
        + totalGastos
      );

      const solicitudesDePagoDetalles = contratos
        .filter(({ solicitudesPagos }) => solicitudesPagos.length > 0)
        .map(({ solicitudesPagos }) => solicitudesPagos)
        .flat()
        .map(({ detalles }) => detalles)
        .flat();

      const montoSolicitado = this.$ObjSumar(solicitudesDePagoDetalles, 'importe');

      const solicitudesPagadas = solicitudesDePagoDetalles
        .filter(({ pagosDetalles }) => pagosDetalles.length > 0)
        .map(({ pagosDetalles }) => pagosDetalles)
        .flat();

      const montoPagado = this.$ObjSumar(solicitudesPagadas, 'importe');

      return {
        cantidadContratos: contratos.length,
        totalContratado,
        totalFacturado,
        totalSolicitado: 0,
        totalPagado: 0,
        importeTotal,
        importeEstimado,
        importePorEstimar,
        montoSolicitado,
        montoPagado,
        avanceFinanciero: (importeEstimado / importeTotal),
      };
    },
    porcentajeDeAvancesContratos(contratos) {
      const avanceProgramado = this.$sumar(contratos.map((contrato) => contrato.avanceProgramado));
      const avanceFisico = this.$sumar(contratos.map((contrato) => contrato.avanceFisico));

      return {
        avanceProgramado,
        avanceFisico,
      };
    },
    mixPorTipo(contratos) {
      const tiposMap = [];
      const tipos = [...new Set(contratos
        .map(({ obra }) => obra.obra.tipo.id))];

      tipos.forEach((id) => {
        const todosLosContratosDeEsteTipo = contratos
          .filter(({ obra }) => obra.obra.tipo.id === id);
        const totalContratadoPorTipo = this.$ObjSumar(todosLosContratosDeEsteTipo, 'total');
        const contratosPorTipo = todosLosContratosDeEsteTipo.map((contrato) => {
          const kp = (contrato.total / totalContratadoPorTipo);
          if (!contrato.ultimoReporte) {
            return {
              ...contrato,
              avanceProgramado: 0,
              avanceFisico: 0,
              avanceFinanciero: 0,
            };
          }

          const { avanceFisico, avanceProgramado } = contrato.ultimoReporte;

          return {
            ...contrato,
            avanceProgramado: (kp * (avanceProgramado / 100)),
            avanceFisico: (kp * (avanceFisico / 100)),
            avanceFinanciero: 0,
          };
        });

        const [contrato] = todosLosContratosDeEsteTipo;

        tiposMap.push({
          descripcion: contrato.obra.obra.tipo.descripcion,
          color: contrato.obra.obra.tipo.color,
          ...this.sumaDeMontoDelContratos(contratosPorTipo),
          ...this.porcentajeDeAvancesContratos(contratosPorTipo),
          subtipos: this.mixPorSubTipo(contratosPorTipo),
          contratos: contratosPorTipo,
        });
      });

      return tiposMap;
    },
    mixPorSubTipo(contratos) {
      const subTiposMap = [];
      const subTipos = [...new Set(contratos
        .map(({ obra }) => obra.obra.subtipo.id))];

      subTipos.forEach((id) => {
        const todosLosContratosDeEsteSubtipo = contratos
          .filter(({ obra }) => obra.obra.subtipo.id === id);

        const totalContratadoPorSubtipo = this.$ObjSumar(todosLosContratosDeEsteSubtipo, 'total');
        const contratosPorSubtipo = todosLosContratosDeEsteSubtipo
          .map((contrato) => {
            const kp = (contrato.total / totalContratadoPorSubtipo);

            // Comprobar si existe un ultimo reporte
            if (!contrato.ultimoReporte) {
              return {
                ...contrato,
                avanceProgramado: 0,
                avanceFisico: 0,
                avanceFinanciero: 0,
              };
            }

            // Extraer los avances programado y fisico del ultimo reporte
            const { avanceFisico, avanceProgramado } = contrato.ultimoReporte;

            return {
              ...contrato,
              avanceProgramado: (kp * (avanceProgramado / 100)),
              avanceFisico: (kp * (avanceFisico / 100)),
              avanceFinanciero: 0,
            };
          });
        const [contrato] = todosLosContratosDeEsteSubtipo;

        subTiposMap.push({
          descripcion: contrato.obra.obra.subtipo.descripcion,
          ...this.sumaDeMontoDelContratos(contratosPorSubtipo),
          ...this.porcentajeDeAvancesContratos(contratosPorSubtipo),
          contratos: contratosPorSubtipo,
        });
      });

      return subTiposMap;
    },
  },
  computed: {
    mixContratos() {
      const contratos = this.listadoContratos.slice();
      const totalContratado = this.$ObjSumar(contratos, 'total');
      return contratos
      // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        })
      // Sacar el ultimo reporte
        .map((contrato) => {
          const ultimoReporte = contrato.reportesFisicos
            .find(({ esUltimo }) => esUltimo === true);

          if (ultimoReporte) {
            ultimoReporte.avanceDiferencia = (ultimoReporte.avanceProgramado
          - ultimoReporte.avanceFisico);
          }

          return {
            ...contrato,
            ultimoReporte,
          };
        })
        // Sacar la ultima estimacion
        .map((contrato) => {
          const ultimaEstimacion = contrato.estimaciones.find(
            ({ numero }) => Number(numero) === contrato.estimaciones.length,
          );
          return {
            ...contrato,
            ultimaEstimacion,
          };
        })
        .map((contrato) => {
          const kp = (contrato.total / totalContratado);
          // Calcular avance financiero
          const totalEstimaciones = this.$ObjSumar(contrato.estimaciones, 'importeEstimado');
          const avanceFinanciero = kp * (totalEstimaciones
            / (contrato.importeTotal + contrato.modificado.importe));

          if (!contrato.ultimoReporte) {
            return {
              ...contrato,
              avanceProgramado: 0,
              avanceFisico: 0,
              avanceFinanciero,
            };
          }

          const { avanceFisico, avanceProgramado } = contrato.ultimoReporte;

          return {
            ...contrato,
            avanceProgramado: (kp * (avanceProgramado / 100)),
            avanceFisico: (kp * (avanceFisico / 100)),
            avanceFinanciero,
          };
        });
    },
    mixCantidadContratos() {
      return this.mixContratos.length;
    },
    mixContratoMarcarExpedienteCompleto() {
      return this.mixContratos
        .filter(({ expediente }) => expediente.length > 0)
        .map((contrato) => {
          const documentosQueAplican = contrato.expediente
            .filter(({ aplica }) => aplica === true);
          const documentosCompletos = documentosQueAplican
            .filter(({ existe }) => existe === true);
          return {
            ...contrato,
            expedienteCompleto: documentosQueAplican === documentosCompletos,
          };
        });
    },
    mixContratosConAnticipos() {
      return this.mixContratos.filter(({ anticipos }) => anticipos.length > 0);
    },
    mixContratosSinAnticipos() {
      return this.mixContratos.filter(({ anticipos }) => anticipos.length <= 0);
    },
    mixContratosConConveniosModificatorios() {
      return this.mixContratos.filter(({ convenios }) => convenios.length > 0);
    },
    mixContratosSinConveniosModificatorios() {
      return this.mixContratos.filter(({ convenios }) => convenios.length <= 0);
    },
    mixContratosConCatalogo() {
      return this.mixContratos.filter(({ catalogoConceptos }) => catalogoConceptos.length > 0);
    },
    mixContratosSinCatalogo() {
      return this.mixContratos.filter(({ catalogoConceptos }) => catalogoConceptos.length <= 0);
    },
    mixContratosConPrograma() {
      return this.mixContratos.filter(({ programas }) => programas.length > 0);
    },
    mixContratosSinPrograma() {
      return this.mixContratos.filter(({ programas }) => programas.length <= 0);
    },
    mixContratosSinDeducciones() {
      return this.mixContratos.filter(({ deducciones }) => deducciones.length <= 0);
    },
    mixContratosConExpedientes() {
      return this.mixContratos.filter(({ expediente }) => expediente.length > 0);
    },
    mixContratosSinExpedientes() {
      return this.mixContratos.filter(({ expediente }) => expediente.length <= 0);
    },
    mixContratosConExpedientesComplementos() {
      return this.mixContratoMarcarExpedienteCompleto
        .filter(({ expedienteCompleto }) => expedienteCompleto === true);
    },
    mixContratosConExpedientesIncomplementos() {
      return this.mixContratoMarcarExpedienteCompleto
        .filter(({ expedienteCompleto }) => expedienteCompleto === false);
    },
    mixContratosConReporteFisico() {
      return this.mixContratos
        .filter(({ reportesFisicos }) => reportesFisicos.length > 0);
    },
    mixContratosSinReporteFisico() {
      return this.mixContratos
        .filter(({ reportesFisicos }) => reportesFisicos.length <= 0);
    },
    // mixContratosEnEjecucion() {
    //   return this.mixContratosConReporteFisico
    //     .filter(({ ultimoReporte }) => ultimoReporte.avanceFisico < 99.99);
    // },
    mixContratosEnEjecucion() {
      return this.mixContratosConReporteFisico
        .filter((contrato) => (contrato.ultimoReporte
          ? contrato.ultimoReporte.avanceFisico < 99.99 : false));
    },
    mixContratosEnEjecucionAtiempo() {
      return this.mixContratosConReporteFisico
        .filter(({ ultimoReporte }) => ultimoReporte.avanceFisico < 99.99)
        .filter(({ ultimoReporte }) => ultimoReporte.avanceDiferencia <= 5);
    },
    mixContratosEnEjecucionconPocoAtraso() {
      return this.mixContratosConReporteFisico
        .filter(({ ultimoReporte }) => ultimoReporte.avanceFisico < 99.99)
        .filter(({ ultimoReporte }) => ultimoReporte.avanceDiferencia > 5
        && ultimoReporte.avanceDiferencia <= 25);
    },
    mixContratosEnEjecucionconMuyAtrasadas() {
      return this.mixContratosConReporteFisico
        .filter(({ ultimoReporte }) => ultimoReporte.avanceFisico < 99.99)
        .filter(({ ultimoReporte }) => ultimoReporte.avanceDiferencia > 25);
    },
    mixContratosEnEjecucionTerminadas() {
      return this.mixContratosConReporteFisico
        .filter(({ ultimoReporte }) => ultimoReporte.avanceFisico >= 99.99);
    },
    mixContratosConEstimaciones() {
      return this.mixContratos.filter(({ estimaciones }) => estimaciones.length > 0);
    },
    mixContratosSinEstimaciones() {
      return this.mixContratos.filter(({ estimaciones }) => estimaciones.length <= 0);
    },
    mixContratosConEstatus() {
      return this.mixContratos.filter(({ estatus }) => estatus);
    },
    mixContratosConEstatusEjecucion() {
      return this.mixContratosConEstatus.filter(({ estatus }) => estatus.nombre === 'En Ejecución');
    },
    mixContratosConEstatusEjecicionAtiempo() {
      return this.mixContratosConEstatusEjecucion
        .filter((contrato) => this.mixContratosEnEjecucionAtiempo
          .includes(contrato));
    },
    mixContratosConEstatusEjecucionSinReportesDeSupervision() {
      return this.mixContratosConEstatusEjecucion
        .filter((contrato) => this.mixContratosSinReporteFisico
          .includes(contrato));
    },
    mixContratosEjecucionSinReporteUltimaSemana() {
      return this.mixContratosEnEjecucion
        .filter(({ ultimoReporte }) => {
          if (!ultimoReporte.fecha) return false;
          return this.diferenciaDias(ultimoReporte.fecha) > 7;
        });
    },
    mixContratosEnEjecucionConProblemaUltimoReporte() {
      return this.mixContratosEnEjecucion
        .filter(({ ultimoReporte }) => ultimoReporte.existeProblema);
    },
    mixContratosTerminadosSinEstimacionFiniquito() {
      return this.mixContratosEnEjecucionTerminadas
        .filter(({ estimaciones }) => estimaciones
          .every((estimacion) => !estimacion.esEstimacionFiniquito));
    },
    mixContratosPorEstatus() {
      const estatusContratos = {};
      this.listadoEstatusContratos.forEach((estatus) => {
        estatusContratos[estatus.nombre] = {
          ...estatus,
          contratos: this.mixContratos
            .filter(({ idContratoEstatus }) => idContratoEstatus === estatus.id),
        };
      });
      return estatusContratos;
    },
    mixProgramas() {
      const programasMap = [];
      const contratosConPrograma = this.mixContratos.filter(({ obra }) => obra !== null);
      const todosLosProgramas = [...new Set(contratosConPrograma
        .map(({ obra }) => obra.obra.programa.id))];

      todosLosProgramas.forEach((id) => {
        const todosLosContratosDeEstePrograma = contratosConPrograma
          .filter(({ obra }) => obra.obra.programa.id === id);
        const totalContratadoPorPrograma = this
          .$ObjSumar(todosLosContratosDeEstePrograma, 'total');

        const contratosPorPrograma = todosLosContratosDeEstePrograma
          .map((contrato) => {
            const kp = (contrato.total / totalContratadoPorPrograma);
            if (!contrato.ultimoReporte) {
              return {
                ...contrato,
                avanceProgramado: 0,
                avanceFisico: 0,
                avanceFinanciero: 0,
              };
            }

            const { avanceFisico, avanceProgramado, avanceFinanciero } = contrato.ultimoReporte;

            return {
              ...contrato,
              avanceProgramado: (kp * (avanceProgramado / 100)),
              avanceFisico: (kp * (avanceFisico / 100)),
              avanceFinanciero: (kp * (avanceFinanciero / 100)),
            };
          });
        const [contrato] = todosLosContratosDeEstePrograma;

        programasMap.push({
          descripcion: contrato.obra.obra.programa.nombre,
          ...this.sumaDeMontoDelContratos(contratosPorPrograma),
          ...this.porcentajeDeAvancesContratos(contratosPorPrograma),
          tipos: this.mixPorTipo(contratosPorPrograma),
          contratos: contratosPorPrograma,
        });
      });

      return programasMap;
    },
  },
};
